var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRejected(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 44,
    height: 44,
    rx: 22,
    fill: "#D33030",
    stroke: "#D33030",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.6528 34.1325L33.4105 31.3748C33.7075 31.0778 33.7075 30.8233 33.4105 30.5263L26.3253 23.4411L33.2408 16.5256C33.5378 16.2286 33.4954 16.0165 33.1984 15.7195L30.7376 13.2587C30.4407 12.9618 30.2285 12.9193 29.9315 13.2163L23.016 20.1318L15.9308 13.0466C15.6338 12.7496 15.3793 12.7496 15.0823 13.0466L12.3246 15.8043C11.9852 16.1437 11.9852 16.3983 12.2822 16.6953L19.3674 23.7805L12.4519 30.696C12.1549 30.993 12.1973 31.2051 12.4943 31.5021L14.955 33.9628C15.252 34.2598 15.4641 34.3022 15.7611 34.0053L22.6766 27.0898L29.7618 34.175C30.1012 34.5144 30.3134 34.4719 30.6528 34.1325Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRejected);
export default __webpack_public_path__ + "static/media/rejected.b27973b2.svg";
export { ForwardRef as ReactComponent };